import environment from '@environments/environment';

/*
 * @NOTE: THESE URLS ARE EXCLUSIVE TO WORKSPACE
 *
 * */
export const WORKSPACE_URLS: Record<string, string> = {
  V1: `${environment.irisApi}/workspace`,
  V2: `${environment.irisApi}/v2/workspace/`,
};

/** @NOTE: This URL is used in the study grid when accessed from the organization details page. It is not used in the study grid when accessed from the study details page. */
export const STUDY_URL: string = `${environment.irisApi}/study/`;
/** @NOTE: This URL is used in the site grid when accessed from the study details page. It is not used in the site grid when accessed from the site details page. */
export const SITE_URL: string = `${environment.irisApi}/site/`;

/** Base URL for address validation and Azure Maps token endpoints. */
export const ADDRESSES_URL = `${environment.irisApi}/address/`;
